module.exports = __webpack_public_path__ + "385560c50e79819627356a5f3ef76832.png";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/HTML.png
// module id = Oh2a
// module chunks = 17